import React from "react";
import { Tabbles } from "../../../components";
import { PiClockUserLight, PiTrash } from "react-icons/pi";
import { FiEdit } from "react-icons/fi";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DefaultWorkingTime = ({
  onlineAppointments,
  offlineAppointments,
  handleDeleteDefaultWorkingTime,
  handleEditDefaultWorkingTime,
  hiddenColumns,
}) => {
  const { t } = useTranslation();
  const filterColumns = (columns) =>
    columns.filter((column) => !hiddenColumns?.includes(column));
  const columns = [`${t("day")}`, `${t("working_hours")}`, `${t("lunch_break")}`, `${t("Edit")}`, `${t("delete")}`];
  return (
    <Row>
      <Col md={12}>
        <Tabbles.TableBlk
          headerIcon={<PiClockUserLight className="header-Icn" />}
          heading={`${t('OnLine')}  ${t('appointments.appointments')}`}
          columns={filterColumns(columns)}
          data={onlineAppointments?.map((Appointment) => ({
            [t("day")]: Appointment.day,
            [t("working_hours")]:
              Appointment.workFromTime && Appointment.workToTime
                ? `${new Date(Appointment.workFromTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })} - ${new Date(Appointment.workToTime).toLocaleTimeString(
                  [],
                  { hour: "2-digit", minute: "2-digit" }
                )}`
                : "-",

            [t("lunch_break")]:
              Appointment.lunchFromTime && Appointment.lunchToTime
                ? `${new Date(Appointment.lunchFromTime).toLocaleTimeString(
                  [],
                  { hour: "2-digit", minute: "2-digit" }
                )} - ${new Date(Appointment.lunchToTime).toLocaleTimeString(
                  [],
                  { hour: "2-digit", minute: "2-digit" }
                )}`
                : "-",

            [t("Edit")]: (
              <div className="editBlkIcon">
                <FiEdit
                  onClick={() => handleEditDefaultWorkingTime(Appointment)}
                  className="editIcon"
                />
              </div>
            ),
            [t("delete")]: (
              <PiTrash
                onClick={() =>
                  handleDeleteDefaultWorkingTime(Appointment.defaultTimingGuid)
                }
                className="delIcon noVerify"
              />
            ),
          }))}
          tabbleClassname="tabble"
        />
      </Col>
      <Col md={12} className="default-working-time-col">
        <Tabbles.TableBlk
          headerIcon={<PiClockUserLight className="header-Icn" />}
          heading={`${t('in_clinic')}  ${t('appointments.appointments')}`}
          columns={filterColumns(columns)}
          data={offlineAppointments?.map((Appointment) => ({
            [t("day")]: Appointment.day,
            [t("working_hours")]:
              Appointment.workFromTime && Appointment.workToTime
                ? `${new Date(Appointment.workFromTime).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })} - ${new Date(Appointment.workToTime).toLocaleTimeString(
                  [],
                  { hour: "2-digit", minute: "2-digit" }
                )}`
                : "-",

            [t("lunch_break")]:
              Appointment.lunchFromTime && Appointment.lunchToTime
                ? `${new Date(Appointment.lunchFromTime).toLocaleTimeString(
                  [],
                  { hour: "2-digit", minute: "2-digit" }
                )} - ${new Date(Appointment.lunchToTime).toLocaleTimeString(
                  [],
                  { hour: "2-digit", minute: "2-digit" }
                )}`
                : "-",

            [t("Edit")]: (
              <div className="editBlkIcon">
                <FiEdit
                  onClick={() => handleEditDefaultWorkingTime(Appointment)}
                  className="editIcon"
                />
              </div>
            ),
            [t("delete")]: (
              <PiTrash
                onClick={() =>
                  handleDeleteDefaultWorkingTime(Appointment.defaultTimingGuid)
                }
                className="delIcon noVerify"
              />
            ),
          }))}
          tabbleClassname="tabble"
        />
      </Col>
    </Row>
  );
};

export default DefaultWorkingTime;
